<template>
  <div>
    <div class="bar center">
      <div class="back" @click="back">
        <img class="back-img" src="../assets/Back_50.png">
      </div>
      <div class="content"><slot name="content"></slot></div>
    </div>
  </div>
</template>
<style lang="stylus">
  .bar
    border-bottom 1px solid #d9d9d9
    height 51px
    width 100%
    line-height 51px
    background-color #fff
    position relative
  .back
    position absolute
    width 100px
    height 100%
    text-align left
  .back:before,
  .back_before
    content ""
    display inline-block
    height 100%
    vertical-align middle
  .back-img
    width 25px
    height 25px
    margin-left 8px
    vertical-align middle
  .content
    width 100%
</style>
<script>
  import router from '../conf/router'

  export default{
    methods: {
      back () {
        router.push('/Me')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// NavigationBar.vue?ddbb218c